// extracted by mini-css-extract-plugin
module.exports = {"marketing_2":"Marketing2Styles_marketing_2__qb25i","wrapper_text":"Marketing2Styles_wrapper_text__3ANGH","text":"Marketing2Styles_text__37rBJ"};